'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fullscreenShareButtons = require('./fullscreenShareButtons.js');

var _fullscreenShareButtons2 = _interopRequireDefault(_fullscreenShareButtons);

var _translationUtils = require('@wix/photography-client-lib/dist/src/utils/translationUtils');

var _translationUtils2 = _interopRequireDefault(_translationUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenShareScreen = function (_React$Component) {
  (0, _inherits3.default)(FullscreenShareScreen, _React$Component);

  function FullscreenShareScreen() {
    (0, _classCallCheck3.default)(this, FullscreenShareScreen);
    return (0, _possibleConstructorReturn3.default)(this, (FullscreenShareScreen.__proto__ || (0, _getPrototypeOf2.default)(FullscreenShareScreen)).apply(this, arguments));
  }

  (0, _createClass3.default)(FullscreenShareScreen, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var shareButtons = _react2.default.createElement(_fullscreenShareButtons2.default, { item: this.props.current.item, itemActions: this.props.actions.itemActions });
      var closeShareScreen = function closeShareScreen() {
        _this2.props.actions.toggleShareScreen(false);
      };
      var shareTitleText = _translationUtils2.default ? _translationUtils2.default.getByKey('Gallery_Fullscreen_Mobile_Share') : 'Share';
      var showShareScreen = this.props.showShareScreen;

      return _react2.default.createElement(
        'div',
        {
          className: 'fullscreen-share-screen' + (showShareScreen ? '' : ' pro-fullscreen-closed') },
        _react2.default.createElement('div', { className: 'fullscreen-share-screen-background' + (showShareScreen ? '' : ' pro-fullscreen-closed'),
          onClick: showShareScreen ? closeShareScreen : null }),
        _react2.default.createElement(
          'div',
          { className: 'fullscreen-share-screen-tab' + (showShareScreen ? '' : ' pro-fullscreen-closed') },
          showShareScreen && _react2.default.createElement(
            'div',
            { className: 'fullscreen-share-screen-tab-title' },
            shareTitleText
          ),
          showShareScreen && shareButtons
        )
      );
    }
  }]);
  return FullscreenShareScreen;
}(_react2.default.Component);

exports.default = FullscreenShareScreen;